<template>
	<div class="sch-head" :class="type === '0' ? 'sch-day' : 'sch-times'">
		<div :class="type === '0' ? 'sch-list' : 'sch-timesList sch-timesList_between'">
			<div v-for="item in items" :class="getClass(item)" :key="item.timestamp" @click="select(item)">
				{{ item.day }} {{ item.name }}
			</div>
		</div>
	</div>
</template>

<script>
import helper from '@/plugins/helper.js';

export default {
	props: ['type', 'date', 'count', 'selected_date'],
	computed: {
		items() {
			let weeks = [];
			let date = new Date(this.date);
			for (let i = 0; i < this.count; i++) {
				weeks.push({
					day: date.getDate(),
					name: helper.getWeekDay(date).shortName,
					month: helper.getYearMonth(date).declension.toLowerCase(),
					holiday: helper.getWeekDay(date).holiday,
					date: helper.dateFormat(date),
					timestamp: date.getTime(),
					origin: new Date(date),
					selected: helper.dateFormat(date) === helper.dateFormat(this.selected_date),
				});
				date.setDate(date.getDate() + 1);
			}
			return weeks;
		},
	},
	methods: {
		select(item) {
			console.log('select', item.origin, this.type);
			if (this.type === '1') {
				this.$emit('input', item.origin);
			}
		},
		getClass(item) {
			let list = [];
			list.push(this.type === '0' ? 'sch-listItem' : 'sch-timesListItem');
			if (this.type === '1' && item.selected) list.push('sch-timesListItem_active');
			return list;
		},
	},
};
</script>
